export default "__VITE_ASSET__BgV2uvgw__"